import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export const pageSearch = {
  'order_type': {
    title: '团购订单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0057',
    defaultVal: 'V013',
    clear: false
  }
}

export default {
  'object_id': {
    title: '销售订单编号',
    type: 'input',
    equation: cusname,
    slot: true
  },
  'process_type_text': {
    title: '销售订单类型'
  },
  'status': {
    describe: true,
    title: '订单状态',
    type: 'select',
    equation: city,
    dictionary: 'A0040'//
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200,
    unSearchRole: 'WLY001'
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009',
    unSearchRole: 'WLY001'
  },
  'zzfld000001': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base',
    unSearchRole: 'WLY001'
  },
  'all_price': {
    title: '整单价税合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'all_quantity': {
    title: '整单件数合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'posting_date': {
    title: '订单创建日期',
    type: 'date',
    equation: all,
    defaultVal: new Date()
  },
  'zzfld00008z': {
    title: '创建人'
  },
  'zzfld00002j': {
    describe: true,
    title: '运达方类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'zzfld00008t': {
    title: '运达方编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '运达方编号'
    }
  },
  'zzfld00008t_dscr': {
    title: '运达方名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'zzfld00002l': {
    title: '收货联系人'
  },
  'zzfld00002m': {
    title: '收货联系电话'
  },
  'zzfld00002n': {
    title: '收货地址',
    width: 200
  },
  'zzfld000028': {
    title: '抬头备注'
  },
  'zzfld00003c': {
    title: '订单来源'
  },
  'zzfld00008x': {
    title: '终端名称'
  },
  'zzfld00000v': {
    describe: true,
    title: '最新状态'
  },
  'zzfld000099': {
    describe: true,
    title: '是否盒外刻字',
    type: 'whether',
    equation: be
  },
  'zzfld00009c': {
    describe: true,
    title: '企业内购(企业内部员工购买)',
    type: 'whether',
    equation: be,
    width: 200
  },
  'zzfld000098': {
    title: '外箱喷码'
  }
}



// WEBPACK FOOTER //
// ./src/views/order-manage/config/groupBuyOrderEditList.js